import React from "react";

const testimonialsection = [
  {
    Name: "Wellness Center",
    designation: "IIT Patna",
    image: "./logo/IITPatnaLogo.png",
    description:
      "I want to express my heartfelt appreciation for the outstanding effort by the Clinical AI Assistance team put into developing the mental health assessment platform...",
  },
  {
    Name: "Shivam Gupta",
    designation: "Revenue Operations Manager at UTHO",
    image: "./img/rajan_tawate.jpg",
    description:
      "Thrilled to connect with the brilliant minds of Clinical AI Assistance Pvt Ltd at the GPAI Summit 2023!...",
  },
  {
    Name: "Dr. Viyas",
    designation: "Doctor at AIIMS Rishikesh",
    image: "./img/logoDarkUpdated.png",
    description:
      "I appreciate the effort made by the Clinical AI Assistance team in establishing US...",
  },
  {
    Name: "Rajan Tawate",
    designation: "Innovations Incharge at NPCI NBBL",
    image: "./img/shivam_gupta.jpg",
    description:
      "Met the Founders of Clinical AI Assistance. Promising product...",
  },
];

const Testimonials = () => {
  return (
    <section className="w-full py-16 overflow-hidden bg-white dark:bg-black relative">

      {/* TOP BLUR + FADE */}
      <div className="pointer-events-none absolute top-0 left-0 w-full h-28 z-10 backdrop-blur-md bg-gradient-to-b from-white/80 dark:from-black/80 to-transparent" />

      {/* BOTTOM BLUR + FADE */}
      <div className="pointer-events-none absolute bottom-0 left-0 w-full h-28 z-10 backdrop-blur-md bg-gradient-to-t from-white/80 dark:from-black/80 to-transparent" />

      {/* CONTENT */}
      <div className="relative z-20">

        {/* GRID */}
        <div className="flex justify-center gap-4 sm:gap-6 px-2 sm:px-4">

          {/* COLUMN 1 */}
          <div className="flex flex-col gap-4 sm:gap-6 animate-scrollUp">
            {[...testimonialsection, ...testimonialsection].map((t, i) => (
              <Card key={i} data={t} />
            ))}
          </div>

          {/* COLUMN 2 */}
          <div className="hidden sm:flex flex-col gap-4 sm:gap-6 animate-scrollDown">
            {[...testimonialsection, ...testimonialsection].map((t, i) => (
              <Card key={i} data={t} />
            ))}
          </div>

          {/* COLUMN 3 */}
          <div className="hidden lg:flex flex-col gap-4 sm:gap-6 animate-scrollUp">
            {[...testimonialsection, ...testimonialsection].map((t, i) => (
              <Card key={i} data={t} />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Testimonials;

/* CARD */
const Card = ({ data }) => {
  return (
    <div
      className="
      w-[260px] sm:w-[300px] md:w-[320px]
      p-4 sm:p-5
      rounded-xl
      bg-gray-100 dark:bg-[#111]
      text-gray-800 dark:text-gray-200
      shadow-md
      border border-gray-200 dark:border-white/10
      hover:scale-[1.03]
      transition duration-300
    "
    >
      <p className="text-sm sm:text-[15px] leading-relaxed mb-4">
        {data.description}
      </p>

      <div className="flex items-center gap-3 mt-4">
        <img
          src={data.image}
          alt=""
          className="w-9 h-9 sm:w-10 sm:h-10 rounded-full object-cover"
        />
        <div>
          <p className="text-sm font-semibold">{data.Name}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {data.designation}
          </p>
        </div>
      </div>
    </div>
  );
};